var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chart',{ref:"chart",attrs:{"type":"bubble","options":_vm.chartOptionsBar,"init-options":{ renderer: 'canvas' }},on:{"mouseover":_vm.mouseover,"mouseout":_vm.mouseout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }